module.exports = __webpack_public_path__ + "static/media/logos-print-feed.c0640d5d.jpg";